/** Default historical lookback shared by V1 syncs and V2 order tracking. */
export const ORDER_TRACKING_BACKFILL_DAYS = 24;
